import { Redirect } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal } from './app';

let SABRedirectInstance = null;

function createSABRedirectInstance() {
    SABRedirectInstance = Redirect.create(getSABAppInstance_Normal());
}

export const shopifyRedirect = (url) => {
    if (!SABRedirectInstance) {
        createSABRedirectInstance();
    }
    SABRedirectInstance.dispatch(Redirect.Action.REMOTE, url);
};

export const shopifyRedirectAdmin = (url) => {
    if (!SABRedirectInstance) {
        createSABRedirectInstance();
    }
    SABRedirectInstance.dispatch(Redirect.Action.ADMIN_PATH, {
        path: url,
        newContext: true,
    });
};